import { Modal as MantineModal } from "@mantine/core";
import type { CustomModalHeaderFactory, IProps } from "./modal-header.types";
import { componentWrapper } from "../../../utilities";

const ModalHeader = componentWrapper<CustomModalHeaderFactory, IProps>("ModalHeader", (props, ref) => {
    return <MantineModal.Header ref={ref} {...props} />;
});

export { ModalHeader };
